import Coming from "../components/Coming";
export default function Blogs() {
    return(
            <>
                <input type="hidden" id="comingDate" value="2024/6/21"/>
                <Coming />
            </>
    );
}